export default "__VITE_ASSET__D1xFEyjA__"